import React from "react";
import PropTypes from "prop-types";
import { Button, Icon } from "discover.medical.react-component-library";

const AssistantButton = ({ assistantButton, showLabel }) => {
  return (
    <Button
      data-testid="assistant-button"
      variant="secondary"
      kind="text"
      padded={false}
      size={"sm"}
      aria-label={!showLabel ? assistantButton.label : ""}
    >
      <Icon
        icon={{
          size: "sm",
          glyph: assistantButton?.icon?.glyph
        }}
      />
      {showLabel ? <span>{assistantButton.label}</span> : <></>}
    </Button>
  );
};

AssistantButton.defaultProps = {
  assistantButton: {
    label: "Micromedex Assistant",
    function: "launchAssistant",
    icon: {
      glyph: "assistant"
    }
  }
};
AssistantButton.propTypes = {
  assistantButton: PropTypes.shape({
    label: PropTypes.string.isRequired,
    function: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      glyph: PropTypes.string.isRequired
    })
  }),
  showLabel: PropTypes.bool
};

export default AssistantButton;
